// FAQMetaData.js
// FAQMetaData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const FAQMetaData = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "FAQPage",
        "@id": "https://www.meatbuddy.in/faq/#webpage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What are your delivery hours?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We deliver fresh meat daily from 9 AM to 6 PM across Bengaluru. Our delivery slots are flexible to accommodate your schedule."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer same-day delivery?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer same-day delivery for orders placed before 4 PM in select areas of Bengaluru. You can check delivery availability for your area during checkout."
            }
          },
          {
            "@type": "Question",
            "name": "What payment methods do you accept?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We accept all major online payment methods including credit/debit cards, UPI, net banking through our secure Razorpay payment gateway. Cash on Delivery is also available in select areas."
            }
          },
          {
            "@type": "Question",
            "name": "How do you ensure meat quality?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We maintain strict quality controls with FSSAI certification. Our meat is processed in hygienic facilities and delivered fresh within hours of processing."
            }
          },
          {
            "@type": "Question",
            "name": "What is your minimum order value?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our minimum order value for free delivery is ₹250. We offer a wide range of fresh cuts starting from ₹100."
            }
          },
          {
            "@type": "Question",
            "name": "How should I store the meat?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Store the meat under refrigeration at 4°C or below. For best results, consume within 48 hours of delivery for chicken and mutton cuts."
            }
          }
        ]
      },
      {
        "@type": "WebPage",
        "@id": "https://www.meatbuddy.in/faq",
        "url": "https://www.meatbuddy.in/faq",
        "name": "Frequently Asked Questions - Meat Buddy",
        "description": "Find answers to common questions about Meat Buddy's premium meat delivery service in Bengaluru.",
        "isPartOf": { "@id": "https://www.meatbuddy.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "https://www.meatbuddy.in",
                "name": "Home"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@id": "https://www.meatbuddy.in/faq",
                "name": "FAQ"
              }
            }
          ]
        }
      },
      {
        "@type": "HowTo",
        "@id": "https://www.meatbuddy.in/faq/#howto",
        "name": "How to Order from Meat Buddy",
        "description": "Step by step guide to ordering fresh meat from Meat Buddy",
        "step": [
          {
            "@type": "HowToStep",
            "name": "Choose Your Products",
            "text": "Browse our selection of fresh chicken and mutton cuts and add them to your cart"
          },
          {
            "@type": "HowToStep",
            "name": "Select Delivery Time",
            "text": "Choose your preferred delivery slot between 9 AM to 6 PM"
          },
          {
            "@type": "HowToStep",
            "name": "Make Payment",
            "text": "Complete your order using our secure payment options"
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <title>FAQ - Meat Buddy | Fresh Meat Delivery Service Bengaluru</title>
      <meta name="title" content="Frequently Asked Questions - Meat Buddy" />
      <meta name="description" content="Find answers to frequently asked questions about Meat Buddy's premium meat delivery service in Bengaluru. Learn about delivery times, payment options, quality standards, storage instructions, and more." />
      <meta name="keywords" content="meat delivery faq, meat buddy help, fresh meat delivery questions, meat shop bangalore faq, meat delivery timings, meat quality standards, meat storage instructions, payment options meat delivery" />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.meatbuddy.in/faq" />
      <meta property="og:title" content="FAQ - Meat Buddy Fresh Meat Delivery" />
      <meta property="og:description" content="Get answers to all your questions about premium meat delivery in Bengaluru. Quality assurance, delivery times, and more." />
      
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Meat Buddy FAQ - Fresh Meat Delivery" />
      <meta name="twitter:description" content="Everything you need to know about our premium meat delivery service in Bengaluru. Quality assured, timely delivery." />
      
      <link rel="canonical" href="https://www.meatbuddy.in/faq" />
      
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};